export const get_app_config = async () => {
  try {
    let headers = {
      'Content-Type': 'application/json',
    };
    let response = await fetch(`/rest/config`, {
      method: 'GET',
      headers,
      credentials: 'include',
    });
    const resp_json = await response.json();
    return resp_json;
  } catch (err) {
    return { error: true, errors: [err.message] };
  }
};

export const get_demo_config = async () => {
  try {
    let headers = {
      'Content-Type': 'application/json',
    };
    let response = await fetch(`/rest/demo/config`, {
      method: 'GET',
      headers,
      credentials: 'include',
    });
    const resp_json = await response.json();
    return resp_json;
  } catch (err) {
    return { error: true, errors: [err.message] };
  }
};

export const get_stripe_config = async () => {
  try {
    let headers = {
      'Content-Type': 'application/json',
    };
    let response = await fetch(`/rest/stripe/config`, {
      method: 'GET',
      headers,
      credentials: 'include',
    });
    const resp_json = await response.json();
    return resp_json;
  } catch (err) {
    return { error: true, errors: [err.message] };
  }
};
